module.exports = __webpack_public_path__ + "static/img/img_qr_code.169d1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_qr_code.png
// module id = PexK
// module chunks = 1